export default __webpack_public_path__ + "a890e872ce37d228de95bf30470b3cdc.svg";